import { CashFlowExpenseByDateItem } from "bus/cash/types/cashFlowExpenseByDate";

export const initValue: CashFlowExpenseByDateItem = {
  comment: '',
  date: '',
  sum: 0,
  cashFlowAccount: null
};